export default __webpack_public_path__ + "static/slide-05-ac1270bace9ace1e0b32050521f5923f.png";